import { useToast } from "@commonlibs";
import { useMutation, UseMutationResult } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { termsApi } from "../api/termsApi";

export interface UpdateTermsPrivacyParams {
    termsAndConditions?: File | null;
    personalDataTreatmentAuthorization?: File | null;
    privacyPolicy?: File | null;
}

export default function useUpdateTermsPrivacy({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, UpdateTermsPrivacyParams> = {}): UseMutationResult<void, unknown, UpdateTermsPrivacyParams> {
    const { showToast } = useToast();
    const translate = useTranslate();

    return useMutation(
        async ({ termsAndConditions, personalDataTreatmentAuthorization, privacyPolicy }: UpdateTermsPrivacyParams) => {
            await termsApi.updateTermsAndConditions({
                termsAndConditions,
                personalDataTreatmentAuthorization,
                privacyPolicy,
            });
        },
        {
            onSuccess: (data, variables, context) => {
                showToast(translate("updateTermsPrivacySuccess"), { type: "success" });
                onSuccess?.(data, variables, context);
            },
            ...options,
        },
    );
}
